import { SpecialEventValueTypes } from "../SpecialEventsQuery/SpecialEventsQuery.consts";
import { ASSISTANT_CHANNELS } from "src/utils/core/consts";

export const CallOutcomeOptions = {
  SCHEDULING_EXIT_REASON: {
    key: "SCHEDULING_EXIT_REASON",
    eventType: "SCHEDULING_EXIT_REASON",
    eventKey: ""
  },
  SCHEDULING_STEP: {
    key: "SCHEDULING_STEP",
    eventType: "SCHEDULING_STEP",
    eventKey: ""
  },
  SMS_SENT: {
    key: "SMS_SENT",
    eventType: "SMS_SENT",
    eventKey: ""
  },
  USER_HUNG_UP: {
    key: "USER_HUNG_UP",
    eventType: "USER_HUNG_UP",
    eventKey: ""
  },
  // Chat only: the per-intent outcome the Chat Overview intent breakdown counts.
  INTENT_OUTCOME: {
    key: "INTENT_OUTCOME",
    eventType: "INTENT_OUTCOME",
    eventKey: ""
  }
};

// Keys are the SCHEDULING_STEP values stored in SCHEDULING_CALLS_DIMENSIONS.
export const SchedulingStepOptions = {
  UNIDENTIFIED: { key: "Unidentified", label: "Patient not identified" },
  REACHED_SKILL: { key: "Reached skill", label: "Reached the skill" },
  VISIT_TYPE_SELECTED: { key: "Visit type selected", label: "Visit type selected" },
  SLOT_NEGOTIATION: { key: "Slot negotiation", label: "Slot negotiation" }
};

// Keys are the INTENT_OUTCOME values stored in CHAT_INTENT_RESOLUTION.
export const IntentOutcomeOptions = {
  CONFIRMED_RESOLVED: { key: "Confirmed resolved", label: "Confirmed resolved" },
  ASSUMED_RESOLVED: { key: "Assumed resolved", label: "Assumed resolved" },
  PRE_CONFIGURED: { key: "Pre-configured", label: "Pre-configured" },
  UNRESOLVED: { key: "Unresolved", label: "Unresolved" }
};

export const CallOutcomeAttributes = {
  [CallOutcomeOptions.SCHEDULING_EXIT_REASON.key]: {
    type: CallOutcomeOptions.SCHEDULING_EXIT_REASON.eventType,
    key: CallOutcomeOptions.SCHEDULING_EXIT_REASON.eventKey,
    label: "Appointment not scheduled reason",
    valueType: SpecialEventValueTypes.STATIC_DROPDOWN,
    valueOptions: [],
    placeholder: "Select reason",
    supportsMultiSelect: true
  },
  [CallOutcomeOptions.SCHEDULING_STEP.key]: {
    type: CallOutcomeOptions.SCHEDULING_STEP.eventType,
    key: CallOutcomeOptions.SCHEDULING_STEP.eventKey,
    label: "Scheduling step",
    valueType: SpecialEventValueTypes.STATIC_DROPDOWN,
    valueOptions: Object.values(SchedulingStepOptions),
    placeholder: "Select step",
    supportsMultiSelect: true
  },
  [CallOutcomeOptions.SMS_SENT.key]: {
    type: CallOutcomeOptions.SMS_SENT.eventType,
    key: CallOutcomeOptions.SMS_SENT.eventKey,
    label: "SMS sent",
    valueType: SpecialEventValueTypes.BOOLEAN_INCLUDED
  },
  [CallOutcomeOptions.USER_HUNG_UP.key]: {
    type: CallOutcomeOptions.USER_HUNG_UP.eventType,
    key: CallOutcomeOptions.USER_HUNG_UP.eventKey,
    label: "User hung up",
    valueType: SpecialEventValueTypes.BOOLEAN_INCLUDED
  },
  [CallOutcomeOptions.INTENT_OUTCOME.key]: {
    type: CallOutcomeOptions.INTENT_OUTCOME.eventType,
    key: CallOutcomeOptions.INTENT_OUTCOME.eventKey,
    label: "Intent outcome",
    valueType: SpecialEventValueTypes.STATIC_DROPDOWN,
    valueOptions: Object.values(IntentOutcomeOptions),
    placeholder: "Select outcome",
    supportsMultiSelect: true
  }
};

export const MOVED_CALL_ROUTING_SUB_TYPES = [CallOutcomeOptions.SMS_SENT.key, CallOutcomeOptions.USER_HUNG_UP.key];

export const SCHEDULING_CALL_OUTCOME_SUB_TYPES = [CallOutcomeOptions.SCHEDULING_EXIT_REASON.key, CallOutcomeOptions.SCHEDULING_STEP.key];

export const INTENT_CALL_OUTCOME_SUB_TYPES = [CallOutcomeOptions.INTENT_OUTCOME.key];

const withSchedulingExitReasons = (schedulingExitReasons) => ({
  ...CallOutcomeAttributes,
  [CallOutcomeOptions.SCHEDULING_EXIT_REASON.key]: {
    ...CallOutcomeAttributes[CallOutcomeOptions.SCHEDULING_EXIT_REASON.key],
    valueOptions: schedulingExitReasons.map((reason) => ({ key: reason, label: reason }))
  }
});

// A hydrated row (saved filter, shared URL) may reference an attribute the current user cannot
// select; keep that one attribute so the row stays visible and editable.
export const getCallOutcomeAttributes = ({
  schedulingExitReasons = [],
  isSchedulingFiltersEnabled = true,
  channel,
  isIntentOutcomeFilterEnabled = false,
  selectedSubType
} = {}) => {
  const attributes = withSchedulingExitReasons(schedulingExitReasons);
  const hiddenSubTypes = [
    ...(isSchedulingFiltersEnabled ? [] : SCHEDULING_CALL_OUTCOME_SUB_TYPES),
    ...(channel === ASSISTANT_CHANNELS.WEB && isIntentOutcomeFilterEnabled ? [] : INTENT_CALL_OUTCOME_SUB_TYPES)
  ];
  return Object.fromEntries(
    Object.entries(attributes).filter(([subType]) => !hiddenSubTypes.includes(subType) || subType === selectedSubType)
  );
};
